import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import NoticeOfIntentChangeRequestStep1Form from '../../../../components/forms/postSecondary/NoticeOfIntentChangeRequestStep1Form';
import Routes from '../../../../config/Routes';
import ChangeRequestType from '../../../../consts/ChangeRequestType';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import InstitutionDTO from '../../../../models/InstitutionDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NoticeOfIntentStep1PageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface NoticeOfIntentStep1PageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class NoticeOfIntentStep1Page extends React.Component<NoticeOfIntentStep1PageProps & RouteComponentProps<RouteObject>, NoticeOfIntentStep1PageState> {
  private readonly _newNoticeOfIntentChangeRequestEntryRef = React.createRef<NoticeOfIntentChangeRequestStep1Form>();

  constructor(props: NoticeOfIntentStep1PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create({
        changeRequestTypeId: ChangeRequestType.NOTICEOFINTENT
      }),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');

    if (id == 'new' || id == ParameterUtil.DEFAULT_STRING) {
      this.setState({ isNew: true });
    }
    if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty() && id !== 'new' && id !== '') {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  private noticeOfIntentSaved = (id: string) => {
    HistoryUtil.replace(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_1, { id: id }));
  }

  private noticeOfIntentSubmit = (id: string) => {
    HistoryUtil.replace(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_1, { id: id }));
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_2, { id: id }));
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={0}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="Program Plan" >
            <NoticeOfIntentChangeRequestStep1Form
              ref={this._newNoticeOfIntentChangeRequestEntryRef}
              changeRequestId={this.state.changeRequest.id}
              selectedInstitution={this.props.selectedInstitution ? this.props.selectedInstitution.id : this.state.changeRequest.institutionId}
              onSave={this.noticeOfIntentSaved}
              onSubmit={this.noticeOfIntentSubmit}
              loading={this.state.loading} />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(NoticeOfIntentStep1Page));